import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";
import { Link, withRouter } from "react-router-dom";
import NewCarSold from "./CarSold";
import { Translation, withTranslation } from "react-i18next";
import BoughtUsedCar from "./BoughtUsedCar";

class TopHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownStatus: false,
      newCarModal: false,
      usedCarBoughtModal: false,
      image: "",
      userRole:[]
    };
  }

  componentDidMount() {
    const image = localStorage.getItem("image");
    this.setState({
      image,
    });
    const userRole = localStorage.getItem("user_role");
    this.setState({
      userRole
    })
  }
  handleNewCarModal = (newCarModal) => {
    this.setState({
      newCarModal,
    });
  };
  handleNewCarBoughtModal = (usedCarBoughtModal) => {
    this.setState({
      usedCarBoughtModal,
    });
  };
  handleClickOutside = () => {
    this.setState({ dropDownStatus: false });
  };

  render() {
    const { dropDownStatus, newCarModal, usedCarBoughtModal, image, userRole } = this.state;
    const { selectionType } = this.props;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <React.Fragment>
              <nav className="navbar navbar-expand-lg fixed-top bg-white border-bottom">
                <div className="container">
                  <div className="mr-auto d-flex align-items-center">
                    <div className="menu-btn">
                      <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                      >
                        <span className="navbar-toggler-icon"></span>
                      </button>
                    </div>
                    <div className="logo">
                      <Link className="navbar-brand" to="/dashboard">
                        <img
                          src="/assets/img/logo.jpg"
                          style={{ width: "70px" }}
                          alt="logo"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="order-lg-2 d-flex align-items-center">
                    <div className="dropdown user-menu">
                      <a
                        href="javascript;:"
                        data-toggle="dropdown"
                        onClick={(e) => {
                          e.preventDefault()
                          this.setState((prev) => {
                            return {
                              dropDownStatus: !prev.dropDownStatus,
                            };
                          });
                        }}
                      >
                        {image ? (
                          <img
                            src={`data:image/png;base64,${image && image}`}
                            className="rounded-circle"
                            style={{ width: "45px", height: "45px" }}
                            alt="logo"
                          />
                        ) : (
                          <img
                            src="/assets/img/avatar.jpg"
                            className="rounded-circle"
                            style={{ width: "45px", height: "45px" }}
                            alt="logo"
                          />
                        )}
                      </a>
                      <div
                        className={
                          dropDownStatus
                            ? "dropdown-menu dropdown-menu-right border-0 shadow p-0 m-0 show"
                            : "dropdown-menu dropdown-menu-right border-0 shadow p-0 m-0"
                        }
                      >
                        {userRole.includes("administration") && (
                        <Link
                          className="dropdown-item"
                          to="/administration/salesperson"
                        >
                          {t("topHeader.administration")}
                        </Link>)}
                        <Link
                          className="dropdown-item"
                          to="/administration/myprofile"
                        >
                          {t("topHeader.myProfile")}
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="/administration/change-password"
                        >
                          {t("topHeader.changePassword")}
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="/goals"
                        >
                          {t("topHeader.userGoals")}
                        </Link>
                        {userRole.includes("manages_sales") && (
                        <Link
                          className="dropdown-item"
                          to="/sales"
                        >
                          {t("topHeader.sales")}
                        </Link>)}
                        <a
                          className="dropdown-item"
                          href="javascript;:"
                          onClick={(e) => {
                            e.preventDefault();
                            localStorage.clear();
                            const { pathname } = this.props.location;
                            const location = {
                              pathname: `/`,
                              state: { from: { pathname: pathname } },
                            };
                            this.props.history.push(location);
                          }}
                        >
                          {t("topHeader.logOut")}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <div className="d-flex flex-wrap responsive-wrap justify-content-lg-center w-100">
                      <ul className="navbar-nav">
                        <li className="nav-item">
                          <Link to="/dashboard" className={
                            selectionType === "0"
                              ? "nav-link active"
                              : "nav-link"
                          }>
                            {t("topHeader.dashboard")}
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/statistics/time"
                            className={
                              selectionType === "1"
                                ? "nav-link active"
                                : "nav-link"
                            }>
                            {t("topHeader.timeStatistics")}
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/statistics/me"
                            className={
                              selectionType === "2"
                                ? "nav-link active"
                                : "nav-link"
                            }>
                            {t("topHeader.myStatistics")}
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/statistics/team"
                            className={
                              selectionType === "3"
                                ? "nav-link active"
                                : "nav-link"
                            }>
                            {t("topHeader.teamStatistics")}
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/statistics/company"
                            className={
                              selectionType === "4"
                                ? "nav-link active"
                                : "nav-link"
                            }>
                            {t("topHeader.companyStatistics")}
                          </Link>
                        </li>
                        {userRole.includes('create_car_brand') && (
                            <>
                              <li className="nav-item align-self-center mt-2 mt-lg-0 ml-0 ml-lg-4">
                                <a
                                    className="nav-link new-car-sold"
                                    href="javascript;:"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      this.handleNewCarModal(true);
                                    }}
                                >
                                  {t("topHeader.newCarSold")}
                                </a>
                              </li>
                              <li className="nav-item align-self-center mt-2 mt-lg-0 ml-0 ml-lg-2">
                                <a
                                    className="nav-link new-car-sold"
                                    href="javascript;:"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      this.handleNewCarBoughtModal(true);
                                    }}
                                >
                                  {t("topHeader.usedCarBought")}
                                </a>
                              </li>
                            </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>

              {newCarModal && (
                <NewCarSold
                  handleNewCarModal={(newCarModal) => {
                    this.handleNewCarModal(newCarModal);
                  }}
                />
              )}
              {usedCarBoughtModal && (
                <BoughtUsedCar
                  handleNewCarBoughtModal={(usedCarBoughtModal) => {
                    this.handleNewCarBoughtModal(usedCarBoughtModal);
                  }}
                />
              )}
            </React.Fragment>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(onClickOutside(TopHeader)));
